import { useEffect, useState } from 'react';

/**
 * Tres estados: `system` sigue al sistema operativo (no se estampa atributo y decide
 * `prefers-color-scheme`); `light`/`dark` fuerzan el tema con `data-theme` en <html>,
 * que es el selector que el CSS ya espera.
 */
export type ThemeChoice = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'mikromanager.theme';

function apply(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', choice);
}

export function loadTheme(): ThemeChoice {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'system';
}

/** Aplica el tema guardado antes del primer render, para que no parpadee. */
export function initTheme(): void {
  apply(loadTheme());
}

export function useTheme(): [ThemeChoice, (next: ThemeChoice) => void] {
  const [choice, setChoice] = useState<ThemeChoice>(loadTheme);

  useEffect(() => {
    apply(choice);
    if (choice === 'system') localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, choice);
  }, [choice]);

  return [choice, setChoice];
}

export const THEME_CYCLE: Record<ThemeChoice, ThemeChoice> = {
  system: 'dark',
  dark: 'light',
  light: 'system',
};

export const THEME_LABEL: Record<ThemeChoice, string> = {
  system: 'Tema: sistema',
  dark: 'Tema: oscuro',
  light: 'Tema: claro',
};

export const THEME_ICON: Record<ThemeChoice, string> = {
  system: '◐',
  dark: '☾',
  light: '☀',
};
